import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isSubmitting as isReduxFormSubmitting } from 'redux-form';

import FabLoadingButton, {
  FabLoadingButtonProps,
} from '@glass/web/components/Button/FabLoadingButton';
import withFormName, { WithFormNameProps } from '@glass/web/components/Form/withFormName';

type FabButtonFormSubmitProps = FabLoadingButtonProps & WithFormNameProps;

function FabButtonFormSubmit({
  form,
  loading,
  disabled,
  onClick,
  children = 'Submit',
  variant,
  size,
  color,
  component,
  params,
  fullWidth,
  className,
  autoFocus,
  startIcon,
  endIcon,
  loadingPosition,
}: FabButtonFormSubmitProps) {
  const selectIsSubmitting = useMemo(() => isReduxFormSubmitting(form), [form]);
  const isSubmitting = useSelector(selectIsSubmitting);

  return (
    <FabLoadingButton
      autoFocus={autoFocus}
      className={className}
      color={color}
      component={component}
      disabled={disabled}
      endIcon={endIcon}
      fullWidth={fullWidth}
      loading={loading || isSubmitting}
      loadingPosition={loadingPosition}
      onClick={onClick}
      params={params}
      size={size}
      startIcon={startIcon}
      type="submit"
      variant={variant}
    >
      {children}
    </FabLoadingButton>
  );
}

export default React.memo(withFormName(FabButtonFormSubmit));
